export default __webpack_public_path__ + "static/media/menu-adquirencia.16f3b893.svg";